import { useEffect, useState } from "react";
import type { FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category/movie", label: "电影" },
  { to: "/category/tv", label: "电视剧" },
  { to: "/category/news", label: "资讯" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative py-1 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
      isActive ? "text-secondary-500" : "text-foreground-700 hover:text-primary-500"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-6 h-16 flex items-center gap-4">
        <Link to="/" className="flex items-center gap-2 flex-shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
            <i className="ri-clapperboard-fill text-background-50 text-xl" />
          </span>
          <span className="text-lg font-bold text-foreground-950 tracking-tight">
            麻豆<span className="text-primary-500">网站</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 ml-4">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={linkClass}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden md:flex items-center ml-auto w-64 lg:w-80">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 资讯"
              className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </div>
        </form>

        <div className="flex md:hidden items-center gap-2 ml-auto">
          <Link
            to="/search"
            className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
          >
            <i className="ri-search-line text-xl" />
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden fixed inset-x-0 top-16 bottom-0 z-40 bg-background-50 animate-fade-in">
          <div className="p-4">
            <form onSubmit={submitSearch} className="mb-4">
              <div className="relative">
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影视 / 资讯"
                  className="w-full pl-9 pr-3 py-2.5 text-sm rounded-md bg-background-100 border border-background-200 text-foreground-900 focus:outline-none focus:border-primary-400"
                />
              </div>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md text-base font-medium transition-colors ${
                      isActive
                        ? "bg-secondary-100 text-secondary-600"
                        : "text-foreground-800 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}